<template>
  <modal
    class="warningModal"
    name="warningModal"
    transition="pop-out"
    :width="modalWidth"
    :height="380"
  >
    <div class="warning_modal_arrow_holder">
      <div class="warning_modal_arrow"></div>
    </div>
    <div class="warning_modal row">
      <div class="col-md-3 suspended_emoji">
        <img src="@/assets/img/clock-warning.svg" />
      </div>
      <div class="col-md-9 epump_sub_content">
        <p class="epump_sub">
          <span class="dear_span">{{ $t("text.dModal.dearCustomer") }}</span
          >{{ $t("text.dModal.subscriptionExpire") }}
        </p>
        <p class="epump_sub">
          <span class="dear_days">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span>
          ({{ $moment(statusInfo.dateDue).format("DD MMMM YYYY") }}).
        </p>
        <p class="epump_sub epump_service">
          {{ $t("text.dModal.serviceDisabled") }}
        </p>
        <div
          class="mt-4"
          v-if="
            this.$route.name == 'IndustrialBranchDashboard' ||
            this.$route.name == 'groupDashboard' ||
            this.$route.name == 'regionDashboard' ||
            this.$route.name == 'dealerDashboard' ||
            this.$route.name == 'industrial_group_dashboard'
          "
        >
          <button
            @click="closeModal"
            class="payment_button mb-3"
            style="
              background-color: #4c2e73;
              font-size: 15px;
              color: white;
              padding: 7px;
              border-radius: 5px;
              border: none;
            "
          >
            {{ $t("text.dModal.continueToPortal") }}
          </button>
        </div>
        <div class="epump_payment" v-else>
          <!-- <router-link
            :to="{
              name: branch
                ? 'branch_invoice'
                : industry
                ? 'industrial_admin_invoice'
                : 'company_invoice',
              query:
                branch && this.$route.query.branchId
                  ? { branchId: this.$route.query.branchId }
                  : industry && this.$route.query.companyID
                  ? { companyID: this.$route.query.companyID }
                  : null,
            }"
            class="view_invoices_text"
            v-show="
              $route.name !== 'company_invoice' &&
              $route.name !== 'branch_invoice' &&
              $route.name !== 'industrial_admin_invoice'
            "
            >{{ $t("text.dModal.viewInvoices") }}</router-link
          > -->
          <!-- <p
            class="view_invoices_text invoice_page"
            v-show="
              $route.name == 'company_invoice' ||
              $route.name == 'branch_invoice' ||
              $route.name == 'industrial_admin_invoice'
            "
            @click="closeModal"
          >
            {{ $t("text.dModal.viewInvoices") }}
          </p> -->
          <button @click="closeModal" class="payment_button">
            {{ $t("text.dModal.continueToPortal") }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 980;

export default {
  name: "warningModal",
  props: ["statusInfo", "branch", "industry"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
      pumpName: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("warningModal");
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
  },
};
</script>
